<template>
  <v-container>
    <v-layout wrap justify-space-around fill-height align-center>
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-flex
            v-show="noticeForm.imgs.length == 0"
            xs6
            sm2
            style="border-radius: 50%;"
            id="parentContainerNoticeImage"
            class="gradiente"
          >
            <label id="img_edit_notice_default">
              <v-img :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"></v-img>
            </label>
          </v-flex>
          <v-flex v-show="noticeForm.imgs.length > 0" xs12 sm8>
            <v-container grid-list-md>
              <v-layout wrap row>
                <v-slide-y-transition v-for="(image, key) in noticeForm.imgs" :key="key">
                  <v-flex :key="key" xs12 md4>
                    <v-card class="d-flex align-center" dark>
                      <v-img :src="image">
                        <v-btn icon color="primary" @click="noticeForm.imgs.splice(key,1)">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-slide-y-transition>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs3>
            <input
                ref="file"
                name="file"
                multiple
                type="file"
                style="display:none"
                accept="image/jpeg, image/png"
                @change="onFileChange($event.target.name, $event.target.files)">
            <v-btn
                block
                class="gradiente"
                style="border-radius: 33px;"
                v-show="flags.updateImage"
                dark
                @click="launchFilePicker"
                :disabled="disableButton"
              >Añadir</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <error v-model="errors.maxExceeded.show" :text="errors.maxExceeded.message"></error>
    <error v-model="errors.wrongImage.show" :text="errors.wrongImage.message"></error>
  </v-container>
</template>

<script>
import error from "../../Dialogs/Error.vue";
export default {
  components: {
    error
  },
  props: ["value"],
  data: () => ({
    noticeForm: {
      imgs: [],
      images: []
    },
    flags: {
      updateImage: true
    },
    errors: {
      maxExceeded: {
        show: false,
        message: ""
      },
      wrongImage: {
        show: false,
        message: ""
      }
    }
  }),
  computed: {
    disableButton () {
      return this.noticeForm.imgs.length >= this.maxAllowedImages
    },
    maxAllowedImages() {
      return 5
    }
  },
  watch: {
    value() {
      if (this.value == null || this.value == []) {
        this.noticeForm = {
          imgs: [],
          images: []
        };
      }
    }
  },
  methods: {
    launchFilePicker () {
      this.$refs.file.click()
    },
    onFileChange (fieldName, fileList) {
      var ignoredFiles = [];
      var wrongFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        if (this.noticeForm.imgs.length + i + 1 > this.maxAllowedImages) {
          ignoredFiles.push(file.name);
        } else {
          this.toDataURL(file).then((result) => {
            this.noticeForm.images.push(result);
            this.noticeForm.imgs.push(result);

            this.$emit("input", this.noticeForm.imgs);
          }).catch((error) => {
            console.log('Cannot read file', error);
            wrongFiles.push(file.name);
          });
        }
      }

      if (ignoredFiles.length === 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado una imagen debido a que se ha excedido el límite.`
        }
      } else if (ignoredFiles.length > 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado ${ignoredFiles.length} imágenes debido a que se ha excedido el límite.`
        }
      }

      if (wrongFiles.length === 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar la siguiente imagen: ${wrongFiles[0]}`
        }
      } else if (wrongFiles.length > 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar las siguientes imágenes: [${wrongFiles.join(', ')}]`
        }
      }
    },
    toDataURL(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
    }
  }
};
</script>

<style>
</style>
